export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Premier-main.0a5c650c.gif","height":300,"width":300,"blurWidth":0,"blurHeight":0};